import { render } from "./ActivityDetailsReport.vue?vue&type=template&id=53d35ba4&scoped=true"
import script from "./ActivityDetailsReport.vue?vue&type=script&lang=js"
export * from "./ActivityDetailsReport.vue?vue&type=script&lang=js"

import "./time-reports.scss?vue&type=style&index=0&id=53d35ba4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d35ba4"]])

export default __exports__